/* eslint-disable react/no-array-index-key */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import SocialMediaIcon from './SocialMediaIcon';
import useCurrentPage from '../../../hooks/useCurrentPage';

const propTypes = {
  isBuilderView: PropTypes.bool,
};

const defaultProps = {
  isBuilderView: false,
};

const SocialMediaIcons = ({ isBuilderView }) => {
  const { socialMedia } = useCurrentPage() || [];

  const visibleSocialMedia = useMemo(() => (
    socialMedia.filter(item => item.enabled).slice(0, 5)
  ), [socialMedia]);

  if ((!visibleSocialMedia || !visibleSocialMedia.length) && isBuilderView) {
    return (
      <div style={{ minHeight: '1.5rem' }} />
    );
  }

  return (
    <>
      {visibleSocialMedia.map(({ link, provider }) => (
        <SocialMediaIcon
          link={link}
          provider={provider}
          key={`social-media-${provider}`}
        />
      ))
      }
    </>
  );
};

SocialMediaIcons.propTypes = propTypes;
SocialMediaIcons.defaultProps = defaultProps;

export default SocialMediaIcons;
